import { z } from "zod";

import {
    agendaDynamicTimePresetFactory,
    agendaDynamicTimePresetZodObject,
} from "./agenda-dynamic-time-preset";
import { agendaPresetZodObject } from "./agenda-preset";
import { agendaPreset_dynamicTimeMeta } from "./agenda-preset.dynamic-time";

const defaultDynamicTimePresets = [
    agendaDynamicTimePresetFactory({
        _id: "agenda_dynamic_time_preset__yesterday",
        _type: "AGENDA_DYNAMIC_TIME_PRESET",
        name: agendaPreset_dynamicTimeMeta.yesterday,
        value: "yesterday",
    }),
    agendaDynamicTimePresetFactory({
        _id: "agenda_dynamic_time_preset__today",
        _type: "AGENDA_DYNAMIC_TIME_PRESET",
        name: agendaPreset_dynamicTimeMeta.today,
        value: "today",
    }),
    agendaDynamicTimePresetFactory({
        _id: "agenda_dynamic_time_preset__tomorrow",
        _type: "AGENDA_DYNAMIC_TIME_PRESET",
        name: agendaPreset_dynamicTimeMeta.tomorrow,
        value: "tomorrow",
    }),
    // agendaDynamicTimePresetFactory({
    //     _id: "agenda_dynamic_time_preset__weekend",
    //     _type: "AGENDA_DYNAMIC_TIME_PRESET",
    //     name: agendaPreset_dynamicTimeMeta.weekend,
    //     value: "weekend",
    // }),
    // agendaDynamicTimePresetFactory({
    //     _id: "agenda_dynamic_time_preset__next-week",
    //     _type: "AGENDA_DYNAMIC_TIME_PRESET",
    //     name: agendaPreset_dynamicTimeMeta["next-week"],
    //     value: "next-week",
    // }),
    // agendaDynamicTimePresetFactory({
    //     _id: "agenda_dynamic_time_preset__next-weekend",
    //     _type: "AGENDA_DYNAMIC_TIME_PRESET",
    //     name: agendaPreset_dynamicTimeMeta["next-weekend"],
    //     value: "next-weekend",
    // }),
];

const agendaPresetsZodObject = z.object({
    timePresets: z
        .array(agendaDynamicTimePresetZodObject)
        .default(defaultDynamicTimePresets),
    presets: z.array(agendaPresetZodObject).default([]),
});

type AgendaPresets = z.infer<typeof agendaPresetsZodObject>;

export { agendaPresetsZodObject, defaultDynamicTimePresets };
export type { AgendaPresets };
